import dev from './config.wyden.dev';
import hml from './config.wyden.hml';
import local from './config.wyden.local';
import prod from './config.wyden.prod';

export default { local, dev, prod, hml };
